import { cn } from "@workspace/web-ui/lib/utils";
import { UrgentCareTaskButtons, AssignedActions } from "~/features/dashboard/components/tasks/urgent-care-task";
import { useState } from "react";
import { PatientSessions, Patient } from "../../patient-logs/api/types";
// import { getTasksByEncounterIdQuery } from "~/features/dashboard/api/tasks/query";
// import { useQuery } from "@tanstack/react-query";

type SessionType = PatientSessions['sessions'][0];

type RecommendedTaskProps = {
    encounterId?: string
    className?: string
    isLoading?: boolean
    patient?: Patient
    assignedTasks?: Array<{
        task_id: string;
        type: string;
        status: string;
        created_at: string;
        cost: number;
        prescription?: {
            prescription_id: number;
            program: string;
            medication: Array<{
                name: string;
                dosage: string;
                duration: number;
                instructions: string;
                refills: string;
                effective_date: string;
            }>;
        };
        instructions?: string;
    }>;
    selectedSession?: SessionType;
    userDoseSpotId?: string;
}

export function ActionTask({ encounterId, className, patient, selectedSession, assignedTasks, userDoseSpotId}: RecommendedTaskProps) {
    const [selectedTaskId, setSelectedTaskId] = useState<string | undefined>();
    
    // Mock data for assigned tasks - replace with actual API call
    // const [assignedTasks, setAssignedTasks] = useState([
    //     {
    //         id: "1",
    //         title: "Pay for appointment",
    //         assignedDate: "23rd March, 2025",
    //         price: "$20.00",
    //         instructions: "Keep your medical results closeby"
    //     },
    //     {
    //         id: "2", 
    //         title: "Pay for medication",
    //         assignedDate: "24th March, 2025",
    //         price: "$15.00",
    //         instructions: "Take medication as prescribed"
    //     }
    // ]);


    const handleAssignMedication = () => {
        // Add your medication assignment logic here
    };

    const handleAssignAppointment = () => {
        // Add your appointment assignment logic here
    };

    // const handleDeleteTask = (taskId: string) => {
    //     setAssignedTasks(prev => prev.filter(task => task.id !== taskId));
    // };

    const handleSelectTask = (taskId: string) => {
        setSelectedTaskId(taskId);
    };

    return (
        <div className={cn("flex flex-col space-y-6 my-2", className)}>
            <UrgentCareTaskButtons 
                onAssignMedication={handleAssignMedication}
                onAssignAppointment={handleAssignAppointment}
                selectedSession={selectedSession}
                userDoseSpotId={userDoseSpotId}
                assignedTasks={assignedTasks}
                patient={patient}
                // encounter={encounter}
            />
            {assignedTasks && assignedTasks.length > 0 && (
            <AssignedActions 
                tasks={assignedTasks}
                encounterId={encounterId ?? ""}
                selectedSession={selectedSession}
                // onDeleteTask={handleDeleteTask}
                onSelectTask={handleSelectTask}
                selectedTaskId={selectedTaskId}
            />
            )}
        </div>
    )
}

